import { useEffect, useState } from 'react';
import { buildSubscriberQuery } from '../utils/rewardClaim';

const useRewardClaimOptions = ({ dispatch, chooseSubNumMethod, subNumType }) => {
  const [phoneRegex, setPhoneRegex] = useState('');
  const [serviceNumberList, setServiceNumberList] = useState([]);

  useEffect(() => {
    dispatch({
      type: 'index/getConfigParamDXP',
      payload: {
        paramCodeList: ['CONTACT_NUMBER_REGEX'],
      },
    }).then(res => {
      if (res?.paramValue) {
        setPhoneRegex(res.paramValue);
      }
    });

    if (chooseSubNumMethod === '67') {
      dispatch({
        type: 'postPaidC2c/qrySubscribersDXP',
        payload: buildSubscriberQuery(subNumType),
      }).then(data => {
        setServiceNumberList(data);
      });
    }
  }, [chooseSubNumMethod, dispatch, subNumType]);

  return {
    phoneRegex,
    serviceNumberList,
  };
};

export default useRewardClaimOptions;
